import CatalogsService from '@/services/catalogs.service.js'

const state = {
    catalogs : null,
    catalogsHash : new Map()
}

const getters =  {
    getCatalogs: (state) => {
        return state.catalogs;
    },
    getCatalogName: (state) => (idCatalog) => {
        
        return  state.catalogsHash.get(idCatalog);
    }
}

const mutations = {
    setCatalogs: (state, catalogs)  => {
        state.catalogs = catalogs;
        state.catalogs.forEach(
            element => {
                state.catalogsHash.set(element.IdCatalogo, element.Descrizione);
            }
        );
    }
}

const actions = {
    getCatalogsFromApi: ({commit}, data) => {      
        return CatalogsService.getCatalogs(data.token, data.codiceLingua).then(
            (data) => {                      
                if(data){
                    commit('setCatalogs', data);
                    return true;
                }
                else{
                    return false;
                }                            
            }          
        ).catch(
            error => {return false}
            );

    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}